import {
  Leaf,
  Smile,
  Pizza,
  Clock4,
  CarFront,
  Shapes,
  Flag,
  Dribbble,
  Lightbulb,
} from 'lucide-react'

const getIconProps = (isActive: boolean) => ({
  size: 20,
  color: isActive ? 'var(--blue-500)' : 'var(--gray-600)',
})

export const getNavigationIcon = (category: string, isActive: boolean) =>
  ({
    suggested: <Clock4 {...getIconProps(isActive)} />,
    smileys_people: <Smile {...getIconProps(isActive)} />,
    animals_nature: <Leaf {...getIconProps(isActive)} />,
    food_drink: <Pizza {...getIconProps(isActive)} />,
    travel_places: <CarFront {...getIconProps(isActive)} />,
    activities: <Dribbble {...getIconProps(isActive)} />,
    objects: <Shapes {...getIconProps(isActive)} />,
    symbols: <Lightbulb {...getIconProps(isActive)} />,
    flags: <Flag {...getIconProps(isActive)} />,
  })[category]
